import { proApi, getProUser } from "@/lib/proApi";
import VoucherStudio from "@/components/vouchers/VoucherStudio";

export default function ProVouchers() {
  const user = getProUser() || {};
  return (
    <div data-testid="pro-vouchers-page">
      <VoucherStudio client={proApi} base="/pro/vouchers" listPath="/pro/vouchers"
        trainerName={user.trainer_name || user.name || ""} />
    </div>
  );
}
